import React from 'react';
import { Accordion, AccordionItem } from './DisclaimerAccordion';

export const Disclaimer = () => {
  return (
    <Accordion>
      <AccordionItem title="Important Information">
        <div className="bg-white">
          <div className="container mx-auto pb-16">
            <div className="md:flex md:items-start md:justify-between w-full mx-auto">
              <div className="flex-1 space-y-3">
                <h3>Terms and conditions apply.</h3>
                <ul className="leading-10">
                  <li>
                    <sup className="text-avenue-ocean-500">1</sup> Subject to us
                    receiving everything we need to issue your bank guarantee.
                  </li>
                  <li>
                    <sup className="text-avenue-ocean-500">2</sup> Special rate for new applications. Interest
                    rates are subject to change.
                  </li>
                  <li>
                    <sup className="text-avenue-ocean-500">3</sup> Deposits up
                    to a limit of $250,000 per account holder are protected by
                    the Australian Government’s Financial Claims Scheme.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </AccordionItem>
    </Accordion>
  );
};
